/**
 * Licensed Materials - Property of ROOTCLOUD
 * THIS MODULE IS "RESTRICTED MATERIALS OF ROOTCLOUD"
 * (c) Copyright ROOTCLOUD Inc. 2021 All Rights Reserved
 *
 * The source code for this program is not published or
 * otherwise divested of its trade secrets
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;
const requestUrlV2 = `${window.env.scimSystem}/api/v2`;

const api = {
  /*
   * 资源管理
   *  获取资源树
   */
  getResourceTree: params => request({
    url: `${requestUrl}/menu-resources`,
    method: "get",
    params
  }),
  // 查询资源列表
  getResourceList: (id, params) => request({
    url: `${requestUrl}/resource/${id}/resource-element`,
    method: "get",
    params
  }),
  // 保存资源列表修改
  saveResource: (id, data) => request({
    url: `${requestUrl}/resource/${id}/resource-element/update-batch`,
    method: "put",
    data
  }),
  // json资源解析
  analysisToResource: code => request({
    url: `${requestUrl}/resource-structure/parsing/${code}`,
    method: "post"
  }),
  // 查看资源详情
  getResourceDetailById: id => request({
    url: `${requestUrl}/resource/${id}`,
    method: "get"
  }),
  // 添加资源
  addResource: data => request({
    url: `${requestUrl}/resource`,
    method: "post",
    data
  }),
  // 修改资源
  editResource: data => request({
    url: `${requestUrl}/resource`,
    method: "put",
    data
  }),
  // 删除资源
  deleteResourceById: id => request({
    url: `${requestUrl}/resource/${id}`,
    method: "delete"
  }),
  // 推送数据
  batchPush: (data, id) => request({
    url: `${requestUrl}/resource/${id}/resource-element/save-batch`,
    method: "post",
    data
  }),
  /*
   * 资源权限配置
   * 获取角色列表
   */
  getRoleList: params => request({
    url: `${requestUrl}/roles`,
    method: "get",
    params
  }),
  // 获取用户树
  getUsersTree: params => request({
    url: `${requestUrl}/user/tenant-users`,
    method: "get",
    params
  }),
  // 获取查询组织
  getOrganization: (params, id) => request({
    url: `${requestUrl}/organization/${id}`,
    method: "get",
    params
  }),
  // 获取带权限资源树
  getAuthorResourceTree: (type, id, clientType, params) => request({
    url: `${requestUrl}/permission/resource/target-id/${id}/target-type/${type}/client-type/${clientType}`,
    method: "get",
    params
  }),
  // 获取对象列表
  getMetaDataTreeApi: params => request({
    url: `${requestUrl}/data-permission/common/meta-data`,
    method: "get",
    params
  }),
  // 获取数据权限类型列表
  getDataScopeApi: params => request({
    url: `${requestUrl}/data-permission/common/data-scope`,
    method: "get",
    params
  }),
  // 数据库表级数据保存
  saveCommonDataApi: data => request({
    url: `${requestUrl}/data-permission/common/table`,
    method: "post",
    data
  }),
  // 解锁资源权限树
  unlockTree: data => request({
    url: `${requestUrl}/permission/ac?ac=${data.ac}&targetId=${data.targetId}&targetType=${data.targetType}`,
    method: "post",
    data: {
      keys: data.keys,
      operation: data.operation
    }
  }),
  // 获取字段权限列表
  getFieldList: params => request({
    url: `${requestUrl}/permission/resource-element`,
    method: "get",
    params
  }),

  // 获取带有权限标识的资源结构树
  getPermissionTree: (targetId, targetType, clientType, params) => request({
    url: `${requestUrl}/permission/competence-resource/target-id/${targetId}/target-type/${targetType}/client-type/${clientType}`,
    method: "get",
    params
  }),
  // 保存字段权限列表
  saveFieldList: data => request({
    url: `${requestUrl}/permission/resource-element`,
    method: "PATCH",
    data
  }),
  // 保存功能权限列表
  saveFunctionList: (targetId, targetType, data) => request({
    url: `${requestUrl}/permission/resource/target-type/${targetType}/target-id/${targetId}`,
    method: "PATCH",
    data
  }),
  /*
   * 数据集注册
   * 获取数据集注册列表
   */
  getDataRegisterList: params => request({
    url: `${requestUrl}/sys-biz-unit/page`,
    method: "get",
    params
  }),
  // 新增数据源
  addDataResource: data => request({
    url: `${requestUrl}/sys-biz-unit/biz/unit/create`,
    method: "post",
    data
  }),
  // 编辑数据源
  editDataResource: data => request({
    url: `${requestUrl}/sys-biz-unit/edit`,
    method: "post",
    data
  }),
  // 删除数据源
  deleteDataResource: data => request({
    url: `${requestUrl}/sys-biz-unit/delete`,
    method: "delete",
    data
  }),
  // 获取restful接口信息
  getRestInfo: (params, url) =>
    // window.env.restService
    request({
      url: `${window.env.restService}${url}`,
      method: "get",
      params
    }),

  /*
   * 数据集配置
   * 获取列表
   */
  getDataSetList: (path, str) => request({
    url: `${requestUrl}/permission/getbiz?resourcePath=${path}&search=${str}&dataPermissionConfig=true`,
    method: "post"
  }),
  // 获取设置规则下拉列表
  getRulesSelectList: params => request({
    url: `${requestUrl}/sys-biz-unit/all`,
    method: "get",
    params
  }),
  // 保存规则设置
  saveRulesSet: data => request({
    url: `${requestUrl}/sys-biz-unit/rule/resource`,
    method: "post",
    data
  }),
  // 删除配置信息
  deleteDataSet: data => request({
    url: `${requestUrl}/sys-biz-unit/rule/relates/move`,
    method: "delete",
    data
  }),

  /*
   * 数据权限配置
   * 查询权限信息
   */
  searchPermissionInfo: data => request({
    url: `${requestUrl}/sys-resource-data-permission/source/id`,
    method: "post",
    data
  }),
  // 获取字段值信息
  getFieldInfo: data => request({
    url: `${requestUrl}/sys-biz-unit/rule/relate/list`,
    method: "post",
    data
  }),
  // 根据id获取字段详情
  getFieldDetail: data => request({
    url: `${requestUrl}/sys-biz-unit/list/ids`,
    method: "post",
    data
  }),
  // 保存权限设置
  savePermissionSet: data => request({
    url: `${requestUrl}/sys-resource-data-permission/edit/permission`,
    method: "post",
    data
  }),
  // 删除设置信息
  deleteSetInfo: data => request({
    url: `${requestUrl}/sys-resource-data-permission/permission/resource/remove`,
    method: "delete",
    data
  }),
  // 检查是否设置状态
  checkIsSet: data => request({
    url: `${requestUrl}/sys-resource-data-permission/source/id/own`,
    method: "post",
    data
  }),
  // 获取参数列表
  getParamsList: params => request({
    url: `${requestUrl}/parameter-config/page`,
    method: "get",
    params
  }),
  // 删除参数项
  deleteParamsItem: data => request({
    url: `${requestUrl}/parameter-config/delete-batch`,
    method: "post",
    data
  }),
  // 添加参数
  addParamsItem: data => request({
    url: `${requestUrl}/parameter-config`,
    method: "post",
    data
  }),
  // 编辑参数
  editParamsItem: data => request({
    url: `${requestUrl}/parameter-config`,
    method: "put",
    data
  }),
  /**
   * @description: 查询租户下元数据结构
   * @param {*}
   * @return {*}
   */
  getMetadataStruct: params => request({
    url: `${requestUrl}/metadata/struct`,
    method: "get",
    params
  }),
  /**
   * @description: 通过编码查询元数据结构的详细信息
   * @param {*}
   * @return {*}
   */
  getMetadataStructByCode: code => request({
    url: `${requestUrl}/metadata/struct/code/${code}`,
    method: "get"
  }),
  /**
   * @description: 条件查询元数据实例
   * @param {*}
   * @return {*}
   */
  getMetadataInstance: (resultStructCode, structCode, page, size) => request({
    url: `${requestUrl}/metadata/instance/query`,
    method: "post",
    data: {
      resultStructCode,
      structCode,
      page,
      size
    }
  }),
  /**
   * @description: 公共数据权限-查询
   * @param {*}
   * @return {*}
   */
  getCommonResource: (resourceId, targetId) => request({
    url: `${requestUrl}/data-permission/common/resource/${resourceId}/target/${targetId}`,
    method: "get"
  }),
  // 查看权限时调用
  viewCommonResource: (resourceId, targetId) => request({
    url: `${requestUrl}/data-permission/table/resource/${resourceId}/target/${targetId}`,
    method: "get"
  }),
  /**
   * @description: 公共数据权限-保存
   * @param {*}
   * @return {*}
   */
  saveCommonResource: data => request({
    url: `${requestUrl}/data-permission/common/resource`,
    method: "post",
    data
  }),
  /**
   * @description: 公共数据权限-保存
   * @param {*}
   * @return {*}
   */
  saveCustomResource: data => request({
    url: `${requestUrl}/data-permission/custom/resource`,
    method: "post",
    data
  }),
  /**
   * @description: 自定义数据权限-查询
   * @param {*}
   * @return {*}
   */
  getCustomResource: (resourceId, targetId) => request({
    url: `${requestUrl}/data-permission/custom/resource/${resourceId}/target/${targetId}`,
    method: "get"
  }),
  /**
   * @description: 数据权限-删除
   * @param {*}
   * @return {*}
   */
  deleteDataPermissionById: id => request({
    url: `${requestUrl}/data-permission/${id}`,
    method: "delete"
  })
};

export default api;
